import React from "react";
import { ArrowLeftRightIcon, Building2Icon, ClipboardListIcon, FileSignatureIcon, HeartPulseIcon, MegaphoneIcon, RouteIcon, BoxIcon } from "lucide-react";
import { coachService, services } from "../data/content";
const icons: Record<string, BoxIcon> = {
  transferencias: ArrowLeftRightIcon,
  clubes: Building2Icon,
  contratos: FileSignatureIcon,
  bienestar: HeartPulseIcon,
  carrera: RouteIcon,
  imagen: MegaphoneIcon
};
export function Services() {
  return <section id="servicios" className="scroll-mt-20 bg-ink text-paper" data-id="element-152" data-mp="13xpk7iosx4cu">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-32" data-id="element-153" data-mp="z3ldn0jg6yca">
        <div className="max-w-2xl" data-id="element-154" data-mp="u59ycaadvvmo">
          <p className="text-sm font-medium text-gold" data-id="element-155" data-mp="u6bcinmp4y8m">Servicios</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl" data-id="element-156" data-mp="q5ho7t5cdhf7">
            Todo lo que la carrera necesita, en un mismo equipo.
          </h2>
        </div>

        <ul className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-157" data-mp="g5quhtolv6g6">
          {services.map(service => {
          const Icon = icons[service.id];
          return <li key={service.id} className="flex flex-col rounded-lg border border-gold/50 bg-ink-soft p-8" data-id="element-158" data-mp="36ad4mtd52wjk">
                <Icon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-159" data-mp="3b50yl7qwwj5j" />
                <h3 className="mt-6 text-lg font-semibold" data-id="element-160" data-mp="2xdciyuhgfcjt">{service.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-paper/70" data-id="element-161" data-mp="32bxjkv0mby8s">{service.description}</p>
              </li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col gap-6 rounded-lg border border-gold bg-ink-soft p-8 md:flex-row md:items-center md:gap-10 md:p-10" data-id="element-162" data-mp="3pyckujqh2vwd">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-gold text-ink" data-id="element-163" data-mp="3g32ddghb1wb7">
            <ClipboardListIcon className="h-6 w-6" aria-hidden="true" data-id="element-164" data-mp="3l0b0zwl82sju" />
          </span>
          <div data-id="element-165" data-mp="24muim1847pa3">
            <h3 className="text-xl font-semibold" data-id="element-166" data-mp="24mchaq6likvb">{coachService.title}</h3>
            <p className="mt-2 max-w-3xl leading-relaxed text-paper/70" data-id="element-167" data-mp="29mgy6hbf1hm2">{coachService.description}</p>
          </div>
        </div>
      </div>
    </section>;
}